module.exports = __webpack_public_path__ + "img/imgWinning.d7bf3abf.png";